import React, { useContext, useEffect } from "react";
import Navbar from '../components/Navbar';
import Carousel from '../components/Carousel';
import Topbar from '../components/Topbar';
import Disclaimer from '../components/terms/disclaimer_body';
import { LanguageContext } from "../context/LanguageContext";

const Page = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("Disclaimer", "terms/disclaimer_body_lang");
  }, [language]);
  const LANGUAGE = componentLanguageData.Disclaimer || { Main: {} };
  return (
    <div>
      <title>{LANGUAGE.Main.Title}</title>
      <Topbar />
      <Navbar />
      <Carousel />
      <Disclaimer />
    </div>
  );
};

export default Page;